import moment from 'moment-timezone'
import * as PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Avatar from '../../../Avatar'
import { getAssetLink } from '../../../helpers/get-asset-link'

const LogResult = ({ building, data, onEditLog, staffPersons }) => {
  const { t } = useTranslation(['action-log'])
  const { name, date, description, category, clientId } = data

  const getProperCategory = (type) => {
    switch (type) {
      case 'shiftNote':
        return t('action-log:shared.shiftNoteLabel')
      case 'checkIn':
        return t('action-log:logResult.checkInCategory')
      default:
        return ''
    }
  }

  const staffPerson =
    staffPersons && staffPersons.length > 0
      ? staffPersons.find((person) => person.value === data.shiftManagerId)
      : null

  return (
    <div
      className="log-result"
      style={category !== 'shiftNote' ? {} : { cursor: 'pointer' }}
      onClick={() => category === 'shiftNote' && onEditLog(data)}
    >
      <div className="log-time">{moment(date).tz(building.timezone).format('h:mm a')}</div>
      <div className="log-body">
        <div className="log-title">{name}</div>
        {category !== 'checkIn' ? <div className="log-information">{description}</div> : null}
      </div>
      <div className="log-resident">
        <div className="log-resident__label">{t('action-log:shared.residentLabel')}</div>
        <div className="log-resident__body">
          {clientId ? (
            <Avatar size="big">
              <img
                src={getAssetLink({
                  path: 'chitown-avatar/avatar',
                  file: clientId.user.avatar || '',
                })}
                alt={''}
              />
            </Avatar>
          ) : null}
          <div className="name">
            {clientId ? `${clientId.user.firstName} ${clientId.user.lastName}` : '-'}
          </div>
        </div>
      </div>
      <div className="log-staff">
        <div className="log-staff__label">{t('action-log:shared.staffLabel')}</div>
        <div className="log-staff__body">
          {staffPerson ? (
            <>
              <Avatar size="big">
                <img
                  src={getAssetLink({
                    path: 'chitown-avatar/avatar',
                    file: staffPerson ? staffPerson.avatar : '',
                  })}
                  alt={''}
                />
              </Avatar>
              <div className="name">{staffPerson ? staffPerson.label : ''}</div>
            </>
          ) : (
            <div className="name">{'-'}</div>
          )}
        </div>
      </div>
      <div className="log-type">
        <div className="log-type__label">{t('action-log:shared.typeLabel')}</div>
        <div className="log-type__body">{getProperCategory(category)}</div>
      </div>
    </div>
  )
}

LogResult.propTypes = {
  data: PropTypes.object,
  onEditLog: PropTypes.func,
  staffPersons: PropTypes.array,
  building: PropTypes.object,
}

export default LogResult
